import DialogArchive from '@/components/dialog-archive/index.vue';
import InputLanguage from '@/components/input-language/index.vue';
import UseDark from '@/components/use-dark/index.vue';

export const CommonComponents = {
  'mph-dialog-archive': DialogArchive,
  'mph-input-language': InputLanguage,
  'mph-use-dark': UseDark,
};
